import React, { useState } from "react";
import { API_BASE_CRM_URL } from "../../Config/Config";
import Swal from "sweetalert2";


export default function AddStatus() {
    const [statusName, setStatusName] = useState('');
    const [statusOrder, setStatusOrder] = useState('');
    const [color, setColor] = useState('#28B8DA');
    const [isDefault, setIsDefault] = useState(0);
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
    
        const newStatus = {
            name: statusName,
            statusorder: statusOrder ? parseInt(statusOrder) : null,
            color,
            isdefault: isDefault ? 1 : 0,
        };
    
        try {
            const response = await fetch(`${API_BASE_CRM_URL}AddLeadStatus`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(newStatus),
            });
    
            const result = await response.json();
            if (result.Status) {
                setLoading(false);
                Swal.fire({
                    title: `Lead Status Add Successfully.`,
                    icon: "success",
                }).then((result) => {
                    if (result.isConfirmed || result.isDismissed) {
                        window.location.reload();
                    }
                });
            } else {
                setLoading(false);
                Swal.fire({
                    title: "Error",
                    text: "Failed to submit request.",
                    icon: "error",
                });
            }
        } catch (error) {
            console.error('Error adding status:', error);
            alert('Failed to add status. Please try again.');
        }
    };

    return (
        <div className="modal fade" id="add-status">
            <div className="modal-dialog modal-dialog-centered custom-modal-two">
                <div className="modal-content">
                    <div className="page-wrapper-new p-0">
                        <div className="content">
                            <div className="modal-header border-0 custom-modal-header">
                                <div className="page-title">
                                    <h4>Add Status</h4>
                                </div>
                                <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body custom-modal-body new-employee-field">
                                <form onSubmit={handleSubmit}>
                                    <div className="row">
                                        <div className="mb-3">
                                            <label className="form-label">Name</label>
                                            <input 
                                                type="text" 
                                                className="form-control"
                                                placeholder="Enter status name"
                                                value={statusName}
                                                onChange={(e) => setStatusName(e.target.value)} 
                                                required
                                            />
                                        </div>
                                        {/* <div className="mb-3">
                                            <label className="form-label">Order</label>
                                            <input 
                                                type="number" 
                                                className="form-control"
                                                placeholder="Enter status order"
                                                value={statusOrder}
                                                onChange={(e) => setStatusOrder(e.target.value)} 
                                            />
                                        </div> */}
                                        {/* <div className="mb-3">
                                            <label className="form-label">Color</label>
                                            <input 
                                                type="color" 
                                                className="form-control"
                                                value={color}
                                                onChange={(e) => setColor(e.target.value)} 
                                            />
                                        </div> */}
                                        <div className="mb-3">
                                            <label className="form-label" htmlFor="default">Default</label>
                                            <input 
                                                type="checkbox" 
                                                id="default"
                                                className="form-check-input ms-2"
                                                checked={isDefault === 1}
                                                onChange={(e) => setIsDefault(e.target.checked ? 1 : 0)} 
                                                style={{ cursor: 'pointer' }}
                                            />
                                        </div>
                                    </div>
                                    <div className="modal-footer-btn">
                                        <button type="button" className="btn btn-cancel me-2" data-bs-dismiss="modal">
                                            Cancel
                                        </button>
                                        <button type="submit" className="btn btn-submit">
                                            {loading ? 'Submitting...' : 'Submit'}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
